import Vue from 'vue'
import VueAxios from 'vue-axios'
import tool from './utils/tool'
import {axios} from './config/axios.config'
import App from './App.vue'
import router from './router/router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import AMap from 'vue-amap'
import Init from './utils/browser'

import './style/common.less'
import './style/reset.less'
import './style/font.less'
import 'swiper/dist/css/swiper.css'
import 'animate.css'

AMap.initAMapApiLoader({
  key: '7e63de52b7fcab0bcfc693786ef3c044',
  plugin: ['AMap.PolyEditor', 'AMap.CircleEditor']
})
Vue.use(VueAxios, axios)
Vue.use(VueAwesomeSwiper)
Vue.use(AMap)
Vue.use(tool)

Init.domClassList()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js